import React, { JSX, useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState, store } from "./redux/store";
import { fetchAllUsers, listenForAuthChanges } from "./redux/authSlice";

import VerificationOverview from "./AUTH/VERIFICATION/VerificationOverview";
import VerifyEmail from "./AUTH/VERIFICATION/VerifyEmail";
import AccountSettings from "./PROFILE/AccountSettings";
import EditProfile from "./PROFILE/EditProfile";
import LoginSecurity from "./PROFILE/LoginSecurity";
import Profile from "./PROFILE/Profile";
import ProfileSettings from "./PROFILE/ProfileSettings";

import ClientDashboard from "./SUPERAPP/CLIENTDASHBOARD/ClientDashboard";
import AddProducts from "./SUPERAPP/DASHBOARD/AddProducts";
import CommerceOnboarding from "./SUPERAPP/DASHBOARD/CommerceOnboarding";
import HostProductOrders from "./SUPERAPP/DASHBOARD/HostProductOrders";
import ProductCheckout from "./SUPERAPP/DASHBOARD/ProductCheckout";
import ProductDetails from "./SUPERAPP/DASHBOARD/ProductDetails";
import Products from "./SUPERAPP/DASHBOARD/Products";
import ProductsHome from "./SUPERAPP/SHOPPING/ProductsHome";
import SellerDashboard from "./SUPERAPP/DASHBOARD/SellerDashboard";
import StoreHome from "./SUPERAPP/DASHBOARD/StoreHome";
import Stores from "./SUPERAPP/DASHBOARD/Stores";
import Home from "./SUPERAPP/DASHBOARD/Home";
import AuthSwitch from "./AUTH/AuthSwitch";


import CategoryDetails from "./SUPERAPP/DASHBOARD/CategoryDetails";
import Wallet from "./PAYMENTMETHODS/Wallet";
import AtlasHome from "./SUPERAPP/HOME/AtlasHome";
import { CurrencyProvider } from "@cosmoola/react-cosmoola-js";

import ShortStaysEdit from "./SUPERAPP/BOOKING/VACATIONRENTALS/EDIT/ShortStaysEdit";
import ShortForm1 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm1";
import ShortForm10 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm10";
import ShortForm2 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm2";
import ShortForm3 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm3";
import ShortForm4 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm4";
import ShortForm5 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm5";
import ShortForm6 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm6";
import ShortForm7 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm7";
import ShortForm8 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm8";
import ShortForm9 from "./SUPERAPP/BOOKING/VACATIONRENTALS/FORMS/ShortForm9";
import ShortAccommodationDetails from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortAccommodationDetails";
import ShortAccomodationPreview from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortAccomodationPreview";
import ShortBookingSuccess from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookingSuccess";
import CancelShortAccomodationBooking from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/CancelShortAccomodationBooking";
import ConfirmGuestRescheduleShortstay from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/ConfirmGuestRescheduleShortstay";
import GuestCancelledBookings from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/GuestCancelledBookings";
import GuestConfirmCancelShortstay from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/GuestConfirmCancelShortstay";
import GuestRescheduleShortstay from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/GuestRescheduleShortstay";
import GuestShortCancelBooking from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/GuestShortCancelBooking";
import GuestShortenShortstay from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/GuestShortenShortstay";
import ShortAccomodationBookings from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/ShortAccomodationBookings";
import ShortBookingDetails from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/ShortBookingDetails";
import ShortBookingsDashboard from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/ShortBookingsDashboard";
import ShortChecking from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/ShortChecking";
import ShortGuestList from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/ShortGuestList";
import ShortReceipt from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/ShortReceipt";
import UpdateGuestRescheduleShortstay from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortBookings/UpdateGuestRescheduleShortstay";
import CancelledShortReservations from "./SUPERAPP/BOOKING/VACATIONRENTALS/EDIT/CancelledShortReservations";
import HostCancelShortBooking from "./SUPERAPP/BOOKING/VACATIONRENTALS/EDIT/HostCancelShortBooking";
import HostConfirmCancelShortstay from "./SUPERAPP/BOOKING/VACATIONRENTALS/EDIT/HostConfirmCancelShortstay";
import ShortStaysDashboard from "./SUPERAPP/BOOKING/VACATIONRENTALS/ShortStaysDashboard";
import CustomerSupport from "SUPERAPP/MESSAGING/CustomerSupport";
import IMessagePreview from "SUPERAPP/MESSAGING/IMessagePreview";
import IMessages from "SUPERAPP/MESSAGING/IMessages";


import Cleaning from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CleaningHome";
import CleaningDashboard from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CleaningDashboard";
import CleaningDetails from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CleaningDetails";
import CleaningPreview from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CleaningPreview";
import CleaningSuccess from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CleaningSuccess";
import HostCancelCleaningBooking from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/HostCancelCleaningBooking";
import CleaningReceipt from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CleaningReceipt";
import CancelCleaningBooking from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CancelCleaningBooking";
import CleaningBookingsDashboard from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CleaningBookingsDashboard";
import CleaningReview from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CleaningReview";
import CleaningForm from "SUPERAPP/BOOKING/CLEANING/DASHBOARD/CleaningForm";

import Books from "SUPERAPP/DASHBOARD/Books";
import AddBook from "SUPERAPP/DASHBOARD/AddBook";
import AddGrocery from "SUPERAPP/SHOPPING/GROCERIES/AddGrocery";
import GroceryDashboard from "SUPERAPP/SHOPPING/GROCERIES/GroceryDashboard";
import GroceryProducts from "SUPERAPP/SHOPPING/GROCERIES/GroceryProducts";
import Hosting from "SUPERAPP/HOME/Hosting";
import SellingPage from "SUPERAPP/HOME/Selling";

import BookRide from "SUPERAPP/BOOKING/RIDE/BookRide";
import DriverCars from "SUPERAPP/BOOKING/RIDE/DriverCars";
import DriversDashboard from "SUPERAPP/BOOKING/RIDE/DriversDashboard";

import RideBookings from "SUPERAPP/BOOKING/RIDE/RideBookings";
import RideCheckout from "SUPERAPP/BOOKING/RIDE/RideCheckout";
import RiderHome from "SUPERAPP/BOOKING/RIDE/RiderHome";
import TripTracking from "SUPERAPP/BOOKING/RIDE/TripTracking";
import OperatorHome from "SUPERAPP/BOOKING/RIDE/OperatorHome";
import StoreCentral from "SUPERAPP/ADMINISTRATION/SELLERCENTRAL/StoreCentral";

import StoreProductCheckout from "SUPERAPP/ADMINISTRATION/SELLERCENTRAL/StoreProductCheckout";
import Store from "SUPERAPP/ADMINISTRATION/SELLERCENTRAL/Store";
import HomeCentral from "SUPERAPP/ADMINISTRATION/HomeCentral";
import FreshStoreCentral from "SUPERAPP/ADMINISTRATION/FRESHCENTRAL/FreshStoreCentral";
import FreshStore from "SUPERAPP/ADMINISTRATION/FRESHCENTRAL/FreshStore";
import FreshStoreCheckout from "SUPERAPP/ADMINISTRATION/FRESHCENTRAL/FreshStoreCheckout";
import FreshStoreBrand from "SUPERAPP/ADMINISTRATION/FRESHCENTRAL/FreshStoreBrand";
import CheckoutSuccess from "SUPERAPP/ADMINISTRATION/SELLERCENTRAL/BUYERCENTRAL/CheckoutSuccess";
import ComingSoon from "GLOBAL/ComingSoon";
import Maintainance from "GLOBAL/Maintainance";

const AppRoutes = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, authLoaded } = useSelector((state: RootState) => state.auth);

  
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);

  useEffect(() => {
    dispatch(listenForAuthChanges());
  }, [dispatch]);

  
{/*
    useEffect(() => {
  if (user) {
    // 1 hour = 60 minutes × 60 seconds × 1000 ms = 3,600,000 ms
    dispatch(startInactivityWatcher({ timeoutMs: 60 * 60 * 1000 }));
  }
}, [dispatch, user]);
  
  
  */}


{/*
    useEffect(() => {
  if (user) {
    dispatch(startInactivityWatcher({ timeoutMs: 5 * 60 * 1000 })); // 5 min
  }
}, [dispatch, user]);
  
  */}


  useEffect(() => {
    dispatch(fetchAllUsers());
    
 
  }, [dispatch]);
  

  


  if (!authLoaded) {
    return <div style={{ textAlign: "center", marginTop: 100 }}></div>;
  }



  const ProtectedSupportRoute = () => {
    const authUser = useSelector((state: RootState) => state.auth.user);
  
    if (!authUser) return <Navigate to="/AuthSwitch" replace />;
  
    const hasAccess = authUser.role?.includes("support") || authUser.role?.includes("admin");
  
    if (!hasAccess) return <Navigate to="/" replace />;
  
    return <Outlet />;
  };

  return (
    <>

    <Routes>
      {/* ✅ Publicly accessible pages/tabs */}
      <Route
  path="/"
  element={
    <>
    
  
        {/*


    
  <GeneralHomes/>  

    <HomeLive />     

      <WhatsNew /> 
        <Route index element={<Ahome />} />
    
       */}
    </>
  }
/>


   

        <Route path="/" element={<Outlet  />}>

<Route index element={<RootRedirect />} />

<Route path="/comingsoon" element={<ComingSoon />} />
      <Route path="/AuthSwitch" element={<AuthSwitch />} />
     <Route path="hosting" element={<Hosting />} />
<Route path="/sellingg" element={<SellingPage />} />


      {/* ── AUTHENTICATED ────────────────────────────────────────── */}

      <Route path="/VerificationOverview/:userId" element={<VerificationOverview />} />
      <Route path="/VerifyEmail/:userId"           element={<VerifyEmail />} />
      <Route path="/Profile/:userId"               element={<Profile />} />
      <Route path="/editprofile/:userId"           element={<EditProfile />} />
      <Route path="/profilesettings/:userId"       element={<ProfileSettings />} />
      <Route path="/accountsettings/:userId"       element={<AccountSettings />} />
      <Route path="/loginsecurity/:userId"         element={<LoginSecurity />} />

<Route path="/imessagepreview"         element={<IMessagePreview />} />
<Route path="/imessages/:chatId" element={<IMessages />} />
<Route path="/support" element={<CustomerSupport />} />


<Route path="/atlas" element={<AtlasHome />} />

<Route path="/HomeCentral" element={<HomeCentral />} />
<Route path="/store/:brandId/:tab/:listingId" element={<StoreCentral />} />
<Route path="/store/:brandId/:tab" element={<StoreCentral />} />
<Route path="/store/:brandId" element={<StoreCentral />} />
<Route path="/store" element={<StoreCentral />} />
<Route path="/pay/:userId" element={<StoreProductCheckout />} />
<Route path="/brand/:brandId" element={<Store />} />
<Route path="/checkoutsuccess/:userId" element={<CheckoutSuccess />} />


<Route path="/freshstore/:brandId/:tab/:listingId" element={<FreshStoreCentral/>} />
<Route path="/freshstore/:brandId/:tab" element={<FreshStoreCentral />} />
<Route path="/freshstore/:brandId" element={<FreshStoreCentral />} />
<Route path="/freshstore" element={<FreshStoreCentral />} />
<Route path="/freshpay/:userId" element={<FreshStoreCheckout />} />
<Route path="/freshbrand/:brandId" element={<FreshStoreBrand />} />


{/********************** SUPERAPP **************************/}


{/***************************RIDE***********************************/}

<Route path="/operatorhome/:userId"             element={<OperatorHome />} />
<Route path="/driverdashboard/:userId"    element={<DriversDashboard />} />
<Route path="/drivercars/:userId"             element={<DriverCars />} />
<Route path="/ridebookings/:userId"             element={<RideBookings />} />

<Route path="/riderhome/:userId"             element={<RiderHome />} />
<Route path="/bookride/:userId"             element={<BookRide />} />
<Route path="/triptracking/:userId"             element={<TripTracking />} />

<Route path="/ridecheckout/:userId"             element={<RideCheckout />} />




{/******VACATION*******/}

<Route path="/shortform1/:userId" element={<ShortForm1 />} />
<Route path="/shortform2/:userId/:listingId" element={<ShortForm2 />} />
<Route path="/shortform3/:userId/:listingId" element={<ShortForm3 />} />
<Route path="/shortform4/:userId/:listingId" element={<ShortForm4 />} />
<Route path="/shortform5/:userId/:listingId" element={<ShortForm5 />} />
<Route path="/shortform6/:userId/:listingId" element={<ShortForm6 />} />
<Route path="/shortform7/:userId/:listingId" element={<ShortForm7 />} />
<Route path="/shortform8/:userId/:listingId" element={<ShortForm8 />} />
<Route path="/shortform9/:userId/:listingId" element={<ShortForm9 />} />
<Route path="/shortform10/:userId/:listingId" element={<ShortForm10 />} />
<Route path="/shortdashboard/:userId" element={<ShortStaysDashboard />} />
<Route path="/shortstaysedit/:listingId" element={<ShortStaysEdit />} />
<Route path="/shortbookingsuccess/:userId/:listingId" element={<ShortBookingSuccess />} />
<Route path="/shortguestlist/:userId" element={<ShortGuestList />} />
<Route path="/shortbookingdetails/:userId/:reservationId" element={<ShortBookingDetails />} />
<Route path="/shortchecking/:listingId" element={<ShortChecking />} />
<Route path="/hostcancelShortBooking/:userId/:listingId" element={<HostCancelShortBooking />} />
<Route path="/GuestShortenShortstay/:guestId/:listingId/:reservationId/:checkIn/:checkOut" element={<GuestShortenShortstay />} />
<Route path="/GuestRescheduleShortstay/:guestId/:listingId/:reservationId/:checkIn/:checkOut" element={<GuestRescheduleShortstay />}/>
<Route path="/UpdateGuestRescheduleShortstay/:guestId/:listingId/:reservationId" element={<UpdateGuestRescheduleShortstay />} />
<Route path="/ConfirmGuestRescheduleShortstay/:guestId/:listingId/:reservationId" element={<ConfirmGuestRescheduleShortstay />} />
<Route path="/GuestConfirmCancelShortstay/:guestId/:listingId/:reservationId" element={<GuestConfirmCancelShortstay />} />
<Route path="/GuestShortCancelBooking/:guestId/:listingId/" element={<GuestShortCancelBooking />} />
<Route path="/GuestCancelledBookings/:guestId" element={<GuestCancelledBookings />} />
<Route path="/shortreceipt/:guestId/:reservationId" element={<ShortReceipt />} />
<Route path="/CancelledShortReservations/:userId" element={<CancelledShortReservations />} />          
<Route path="/HostCancelShortBooking/:hostId/:listingId/:reservationId" element={<HostCancelShortBooking />} />
<Route path="/HostConfirmCancelShortstay/:hostId/:guestId/:listingId/:reservationId" element={<HostConfirmCancelShortstay />}/>
       <Route path="/roomdetails/:listingId" element={<ShortAccommodationDetails />} />
  <Route path="/shortaccomodationpreview/:userId/:listingId" element={<ShortAccomodationPreview />} />
<Route path="/ShortAccomodationBookings/:userId" element={<ShortAccomodationBookings />} />
<Route path="/cancelshortaccomodationbooking/:guestId/:listingId/:reservationId" element={<CancelShortAccomodationBooking />} />
<Route path="/ShortBookingsDashboard/:userId" element={<ShortBookingsDashboard />} />






{/* ─── CLEANING HOSTING ─── */}
<Route path="/cleaningdashboard/:userId"                                    element={<CleaningDashboard />} />
<Route path="/cleaning"                                                     element={<Cleaning />} />
<Route path="/cleaningdetails/:listingId"                                   element={<CleaningDetails />} />
<Route path="/cleaningpreview/:userId/:listingId"                                   element={<CleaningPreview />} />
<Route path="/cleaningpreview/:userId/:listingId"                                   element={<CleaningPreview />} />
<Route path="/cleaning-success" element={<CleaningSuccess />} />
<Route path="/cleaningform/:userId"                                         element={<CleaningForm />} />
<Route path="/cleaningform/:userId/:listingId"                              element={<CleaningForm />} />
<Route path="/hostcancelcleaningbooking/:hostId/:listingId/:reservationId"  element={<HostCancelCleaningBooking />} />
<Route path="/CleaningBookingsDashboard/:userId"                                     element={<CleaningBookingsDashboard />} />
<Route path="/cleaningrating/:guestId/:listingId/:reservationId"            element={<CleaningReview />} />
<Route path="/cancelcleaningbooking/:guestId/:listingId/:reservationId"     element={<CancelCleaningBooking />} />
<Route path="/cleaningreceipt/:guestId/:reservationId" element={<CleaningReceipt />} />






{/********************** COMMERCE DASHBOARD**************************/}
  
      <Route path="/onboarding/:userId" element={<CommerceOnboarding />} />
      <Route path="/CommerceOnboarding"           element={<CommerceOnboarding/>} />
<Route path="/CommerceOnboarding/:editBrandId" element={<CommerceOnboarding/>} />
      <Route path="/ClientDashboard/:userId" element={<ClientDashboard />}  />
      <Route path="/SellerDashboard/:userId" element={<SellerDashboard />}  />
            
            <Route path="/Products" element={<Products/>}  />
<Route path="/AddProducts" element={<AddProducts />} />
<Route path="/AddProducts/:listingId" element={<AddProducts />} />
<Route path="/HostProductOrders/:userId" element={<HostProductOrders />} />
<Route path="/ProductDetails/:listingId" element={<ProductDetails />} />
<Route path="/ProductCheckout/:userId" element={<ProductCheckout />} />
<Route path="/StoreHome/:brandId" element={<StoreHome />} />
<Route path="/Stores" element={<Stores />} />
<Route path="/categorydetails/:categoryId" element={<CategoryDetails />} />

<Route path="/Books" element={<Books/>}  />
<Route path="/AddBook" element={<AddBook />} />
<Route path="/AddBook/:listingId" element={<AddBook />} />

   
     


 <Route path="/Groceries/:userId" element={<GroceryDashboard />}  />
  <Route path="/GroceryProducts" element={<GroceryProducts/>}  />
<Route path="/AddGrocery" element={<AddGrocery />} />


 <Route path="/Wallet/:userId" element={<Wallet />} />



    <Route path="*" element={<Navigate to={user ? "/" : "/authswitch"} replace />} />
        </Route>

    
    </Routes>
</>
);};

const RootRedirect: React.FC = () => {
  const { user } = useSelector((s: RootState) => s.auth);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) return;
    const timer = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(timer);
  }, [user]);

  if (show) return <ComingSoon />;
  return <ComingSoon />;
};

const App = () => (
  <Provider store={store}>
    <Router>

      <CurrencyProvider 
  apiKey={process.env.REACT_APP_COSMOOLA_PUBLISHABLE_KEY!}
>
      <AppRoutes />

        </CurrencyProvider>
    </Router>
  </Provider>
);

export default App;